var map = {
	"./adult/de/2 7 Ordkjedetest-Starter-testen.mp3": 92,
	"./adult/nn/2 7 Ordkjedetest-Starter-testen.mp3": 758,
	"./adult/no/2 7 Ordkjedetest-Starter-testen.mp3": 759,
	"./youth/de/2 7 Ordkjedetest-Starter-testen.mp3": 760,
	"./youth/nn/2 7 Ordkjedetest-Starter-testen.mp3": 761,
	"./youth/no/2 7 Ordkjedetest-Starter-testen.mp3": 762,
	"./youth/se/2 7 Ordkjedetest-Starter-testen.mp3": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;